const state = {
  currentProject: {},
  templates: [],
  projects: [],
  checkedProjects: [],
  folders: [],
};
export default state;
